/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceAssignmentRequestBody
 */
export interface DeviceAssignmentRequestBody {
    /**
     * 
     * @type {number}
     * @memberof DeviceAssignmentRequestBody
     */
    deviceId: number;
}

export function DeviceAssignmentRequestBodyFromJSON(json: any): DeviceAssignmentRequestBody {
    return DeviceAssignmentRequestBodyFromJSONTyped(json, false);
}

export function DeviceAssignmentRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceAssignmentRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
    };
}

export function DeviceAssignmentRequestBodyToJSON(value?: DeviceAssignmentRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'device_id': value.deviceId,
    };
}

